export default __webpack_public_path__ + "static/flovatar-cd98f5e04537f6f8ea82fc255ecb590a.png";